export default [
  'Melee',
  'Load Bearing',
  'ALICE',
  'WW2',
  'Pack',
  'Combat',
  'Support',
  'Misc',
  'Rations',
  'Tools',
  'Medical',
  'Comms',
  'Generic',
  'Modern Russian LBE',
  'Chest Rig',
  'Vietnam',
  'Webbing Set',
];
